"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(_ref) {
  var _ref$importantFields = _ref.importantFields,
    importantFields = _ref$importantFields === void 0 ? [] : _ref$importantFields,
    project = _ref.project;
  if (project) {
    var _loop = function _loop(i) {
      var field = "field_".concat(i);
      var path = "fields.".concat(field);
      importantFields = importantFields.filter(function (f) {
        return f.path !== path;
      });
      var label = project.fields[field];
      if (!label) {
        return "continue";
      }
      importantFields.push({
        label: label,
        path: path,
        identifiable: project.fields["".concat(field, "_is_identifiable")]
      });
    };
    for (var i = 1; i <= 5; i++) {
      var _ret = _loop(i);
      if (_ret === "continue") continue;
    }
  }
  return importantFields;
};
exports["default"] = _default;